import React, { useState, useEffect } from 'react';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { ComplementaryActivityCard } from '@/pages/complementary-activity/complementary-activity-card';
import { CardWrapper } from '@/components/ui/card';

export function CourseClassroomActivities(props) {
  const { selectedItemId, setEmptyTabs } = props;
  const client = useClient();
  const [loading, setLoading] = useState(true);
  const [activities, setActivities] = useState([]);

  const getActivities = async () => {
    setLoading(true);
    const url = `activities?filter[learning_system_items.id]=${selectedItemId}`;
    const { data, error } = await client.fetch(url);
    setLoading(false);
    if (error) {
      toast.error('Erro ao buscar atividades.');
    } else {
      setActivities(data);
      if (data.length > 0) {
        setEmptyTabs(false);
      }
    }
  };

  useEffect(() => {
    if (selectedItemId) {
      getActivities();
    }
  }, [selectedItemId]);

  return loading ? (
    <Loader />
  ) : activities.length > 0 ? (
    (activities || []).map((activity, i) => (
      <CardWrapper key={i}>
        <ComplementaryActivityCard activity={activity} />
      </CardWrapper>
    ))
  ) : (
    <EmptyState
      type="content"
      title="Sem conteúdo"
    />
  );
}
